import { render, staticRenderFns } from "./wwtService.vue?vue&type=template&id=6d27a07c&scoped=true&"
import script from "./wwtService.vue?vue&type=script&lang=js&"
export * from "./wwtService.vue?vue&type=script&lang=js&"
import style0 from "./wwtService.vue?vue&type=style&index=0&id=6d27a07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d27a07c",
  null
  
)

export default component.exports